/**
 * DevExtreme (esm/core/templates/child_default_template.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    TemplateBase
} from "./template_base";
export class ChildDefaultTemplate extends TemplateBase {
    constructor(name) {
        super();
        this.name = name
    }
}
